import "../../styles/common/successToast.css";

const SuccessToast = ({ message, background = true }) => {
  if (!message) return;
  return (
    <div className="success-toast-container">
      <div
        className={
          background ? "success-toast green-background" : "success-toast"
        }
      >
        {message}
      </div>
    </div>
  );
};

export default SuccessToast;
